<template lang="pug">
div.row
    div.col-sm-12.text-center(v-if="isVoid")
        small.block {{ pgsql_transaction.void_details.void_reason }}
        small
            | Voided by&nbsp;
            span {{ pgsql_transaction.void_details.voided_by.staff_name }}
            | &nbsp;on {{ receiptDateFormat(pgsql_transaction.receipt_date) }}

</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';
import Unleash from '@js/plugins/unleash';

export default {
    mixins: [receiptMixin],
    computed: {
        ...mapGetters('transactionPostgres', ['pgsql_transaction', 'isVoid']),
    },
};
</script>
